import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@uranda/commons';
import { AccountVerifyRequest } from '../../models/requests/account.verify.model';
import { InvitationInfo } from '../../models/partner-member.model';
import { AccountDeletionStatus } from '../../models/partner.model';

@Injectable({
  providedIn: 'root',
})
export class AccountService extends ApiService {
  async verifyAccount(request: AccountVerifyRequest): Promise<any> {
    const response = await this.post('/v1/account/verify', request);
    return response;
  }

  /** True if the email-verification link can still be used to set the first password. */
  async verifyStatus(token: string): Promise<boolean> {
    const queryParameters = new HttpParams().set('token', token);
    const response = await this.get('/v1/account/verify-status', queryParameters);
    return response.data;
  }


  async toggleHolidayMode(enabled: boolean): Promise<any> {
    return await this.put('/v1/account/holiday-mode', enabled);
  }

  async toggleWalletVisibility() {
    return await this.put('/v1/account/toggle-hide-wallet-amount');
  }

  /** Richiede la cancellazione dell'account: viene programmata (non immediata), la clinica è disattivata subito. */
  async deleteAccount(): Promise<AccountDeletionStatus> {
    const response = await this.delete('/v1/partner/account');
    return response?.data;
  }

  async getAccountDeletionStatus(): Promise<AccountDeletionStatus> {
    const response = await this.get('/v1/partner/account/deletion');
    return response.data;
  }

  async cancelAccountDeletion(): Promise<AccountDeletionStatus> {
    const response = await this.post('/v1/partner/account/deletion/cancel');
    return response.data;
  }

  async verifyEmailChange(token: string) {
    const queryParameters = new HttpParams().set('token', token);
    return await this.post('/v1/account/verify-email-change', queryParameters);
  }

  async getInvitation(token: string): Promise<InvitationInfo> {
    const queryParameters = new HttpParams().set('token', token);
    const response = await this.get('/v1/account/invitation', queryParameters);
    return response.data;
  }

  async acceptInvitation(token: string, password: string, passwordConfirm: string): Promise<void> {
    await this.post('/v1/account/invitation/accept', { token, password, passwordConfirm });
  }
}
